import React from "react";
import styles from "./Settings.module.css";
import { Button } from "@material-ui/core";
import { useSetting } from "../../Context/SettingContext";
import { Card, CardContent, Typography } from "@material-ui/core";
import Form from "./Form/Form";

import { useHistory } from "react-router-dom";
import Vat from "./Vat";
import PrinterLocation from "./PrinterLocation";
// import LanguageSelector from './LanguageSelector';
// import PrinterSettings from './PrinterSettings';
const Settings = () => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { handleSettingDialogOpen } = useSetting();
  //(user)

  if (!user) {
    history.push("/login");
  }

  return (
    <div className={styles.pageContainer}>
      <section className={styles.stat}>
        <Form user={user} />
      </section>
      <section className={styles.stat}>{/* <Vat/> */}</section>
      <div>
        <section className={styles.stat}>
          <Vat />
        </section>
        <section className={styles.stat}>
          <PrinterLocation />
        </section>
      </div>

      {/* Language Settings */}
      {/* <Card>
        <CardContent>
          <Typography variant="h6">Language Settings</Typography>
          <Typography>Select the display language for the application.</Typography>
          <LanguageSelector />
        </CardContent>
      </Card> */}
    </div>
  );
};

export default Settings;
